<script lang="ts">
  import { goto } from '$app/navigation';
  import { createCourse } from '$lib/api/courses';
  import CourseEditor from '$lib/components/courses/CourseEditor.svelte';
</script>

<h2>New Course</h2>
<div class="card">
  <div class="card-body py-5">
    <CourseEditor onSave={async course => {
      const created = await createCourse(course);
      goto(`/admin/courses/${created.id}`);
    }} />
  </div>
</div>
